import type { ComponentProps, SVGProps } from 'react'

import NotFoundImage from '@/assets/images/not-found.svg'
import { classNames } from '@/utils/helpers'

type EmptyTableContentProps = ComponentProps<'div'> & {
  imageProps?: SVGProps<SVGElement>
}

export const EmptyTableContent = (props: EmptyTableContentProps) => {
  const { className, children, imageProps, ...rest } = props

  return (
    <div
      {...rest}
      className={classNames(
        'flex flex-col items-center rounded-lg bg-card p-4',
        className,
      )}
    >
      <NotFoundImage
        width={64}
        height={64}
        {...imageProps}
      />
      <p className="text-center text-sm font-medium text-secondary-300">
        {children}
      </p>
    </div>
  )
}
